export default __webpack_public_path__ + "static/media/CoffeeMug2.9a2ea82b.png";